import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class WorksMaterialConsumptionRateNormsApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS, {
			entity: 'works_material_consumption_rate_norms',
		})
	}
}